export default __webpack_public_path__ + "static/media/kartoffel_startpage_cleaned.487e474c.png";